import React, { Component } from "react";

export default class Other extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    // console.log(this.props.user.displayName);
    return (
      <div className="userName animated fadeIn">
        {this.props.user ? (
          <>
            <p>
              Welcome
              <br /> {this.props.user}
            </p>
            {/* <img src={this.props.image} /> */}
          </>
        ) : (
          "no"
        )}
      </div>

      // <div>{this.props.user.userName}</div>
    );
  }
}
